import {catchUnhandledDataGridActions} from '@dms/shared';

import {openBulkOperationActionDialog, type BulkOperationActionCallback} from 'features/eag-grid';

import {TaskReassignBulkForm} from '../components/TaskReassignBulkForm/TaskReassignBulkForm';

export const taskBulkOperationActionCallback: BulkOperationActionCallback = (action) => {
  if (action.actionKey === 'REASSIGN') {
    return openBulkOperationActionDialog(action, <TaskReassignBulkForm action={action} />);
  }
  catchUnhandledDataGridActions(action.actionKey);
};
